// extracted by mini-css-extract-plugin
export default {"IonModal":"BusinessRegisteredModal_IonModal__NnKT6","Text__Header":"BusinessRegisteredModal_Text__Header__8LfYB","Text__Content":"BusinessRegisteredModal_Text__Content__bqOsl"};